<template>
  <app-logged id="IndustriasCreate">
    <v-flex
      :sm6="!!industria.id"
      xs12
    >
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
        tag="form"
      >
        <v-form>
          <app-widget
            actions
            :class-widget="
              !!industria.id ? 'xs12' : 'md6 offset-md3 sm8 offset-sm2 xs12'
            "
          >
            <div slot="widget-content">
              <AppFormHeader
                title="Informações gerais"
                icon="description"
              />
              <validation-provider
                name="cnpj"
                rules="required|max:18"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-mask="`##.###.###/####-##`"
                  type="tel"
                  v-model="industria.cnpj"
                  label="CNPJ"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="razão social"
                rules="required|max:125"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="industria.razao_social"
                  label="Razão social"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="nome fantasia"
                rules="required|max:125"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="industria.nome_fantasia"
                  label="Nome fantasia"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <v-checkbox
                v-model="industria.inscricao_isento"
                :label="`Isento de inscrição estadual`"
              />
              <validation-provider
                v-if="!industria.inscricao_isento"
                name="inscrição estadual"
                rules="max:11"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-mask="`########-##`"
                  type="tel"
                  v-model="industria.inscricao_estadual"
                  label="Inscrição estadual"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <AppFormHeader
                title="Informações de endereço"
                icon="home"
              />
              <validation-provider
                name="endereco"
                rules="required|max:255"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="industria.endereco"
                  label="Endereço"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="complemento"
                rules="max:300"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="industria.complemento"
                  label="Complemento"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="cep"
                rules="required|max:9"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  v-model="industria.cep"
                  label="CEP"
                  v-mask="`#####-###`"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="cidade"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  label="Cidade/Estado"
                  :items="cidades"
                  clearable
                  v-model="industria.cidade_id"
                  :return-object="false"
                  :item-text="cidade"
                  item-value="id"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <AppFormHeader
                title="Website"
                icon="launch"
              />
              <validation-provider
                name="url"
                rules="max:300"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="industria.website"
                  label="URL"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
            </div>
            <div slot="widget-actions">
              <v-spacer />
              <app-button
                v-if="industria.id"
                @click.native="remove"
                color="error"
                class="mr-2"
              >
                remover
              </app-button>
              <app-button
                @click.native.prevent="save()"
                :disable="invalid"
              >
                salvar
              </app-button>
            </div>
          </app-widget>
        </v-form>
      </validation-observer>
    </v-flex>
    <v-flex
      v-if="!!industria.id"
      sm6
      xs12
    >
      <app-lista-telefone class="mb-4" />
      <app-lista-email class="mb-4" />
      <app-image-upload />
    </v-flex>
  </app-logged>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import AppImageUpload from '@/components/AppImageUpload'
import AppLogged from '@/components/layouts/AppLogged'
import AppWidget from '@/components/AppWidget'
import AppListaTelefone from '@/components/AppListaTelefone'
import AppListaEmail from '@/components/AppListaEmail'
import AppButton from '@/components/AppButton'
import AppFormHeader from '@/components/AppFormHeader'
export default {
  name: 'IndustriasCreate',
  components: {
    AppWidget,
    AppLogged,
    ValidationProvider,
    ValidationObserver,
    AppListaTelefone,
    AppListaEmail,
    AppButton,
    AppImageUpload,
    AppFormHeader
  },
  computed: {
    ...mapGetters(['cidades', 'industria'])
  },
  methods: {
    ...mapActions(['postSaveIndustria', 'deleteIndustria']),
    cidade: item => `${item.nome}/${item.acronimo}`,
    goToIndustriaIndex () {
      this.$router.push({
        name: 'industrias-index'
      })
    },
    remove () {
      if (confirm('Confirme a exclusão desta industria.')) {
        this.deleteIndustria().then(res => {
          this.goToIndustriaIndex()
        })
      }
    },
    save () {
      this.$refs.observer.validate().then(result => {
        if (result) {
          this.postSaveIndustria().then(res => {
            this.goToIndustriaIndex()
          })
        }
      })
    }
  },
  mounted () {}
}
</script>
